import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import reducer, { initialState } from '../reducers/index'
import { composeWithDevTools } from '@redux-devtools/extension'
import { thunk } from 'redux-thunk'

import InsightHighlightsWebService from '../../services/InsightHighlightsWebService'
import LearningTracksWebService from '../../services/LearningTracksWebService'
import YourWorkspacesService from '../../services/YourWorkspacesService'

const logger = () => (dispatch:any) => (action:any) => {
  return dispatch(action)
}

const insightHighlightsWebService = new InsightHighlightsWebService()
const learningTracksWebService = new LearningTracksWebService()
const yourWorkspacesService = new YourWorkspacesService()

// @ts-ignore
export const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(
    applyMiddleware(
      thunk,
      logger,
      insightHighlightsWebService.router,
      learningTracksWebService.router,
      yourWorkspacesService.router
    )
  )
)

